import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance1gp5vi6mchd0u as Companion_getInstance } from './HttpFetcher.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_fetchInterceptors() {
  _init_properties_fetch_kt__lt4al4();
  return fetchInterceptors;
}
var fetchInterceptors;
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  HttpMethod_GET_instance = new (HttpMethod())('GET', 0);
  HttpMethod_POST_instance = new (HttpMethod())('POST', 1);
  HttpMethod_PUT_instance = new (HttpMethod())('PUT', 2);
  HttpMethod_PATCH_instance = new (HttpMethod())('PATCH', 3);
  HttpMethod_DELETE_instance = new (HttpMethod())('DELETE', 4);
  HttpMethod_HEAD_instance = new (HttpMethod())('HEAD', 5);
}
var HttpMethod_GET_instance;
var HttpMethod_POST_instance;
var HttpMethod_PUT_instance;
var HttpMethod_PATCH_instance;
var HttpMethod_DELETE_instance;
var HttpMethod_HEAD_instance;
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var ConnectionExceptionClass;
function ConnectionException() {
  if (ConnectionExceptionClass === VOID) {
    class $ extends FetchException() {
      constructor(message, cause) {
        return new.target.new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$(message, cause);
      }
      static new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$(message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_com_lightningkite_kiteui_FetchException_xi8rsd_k$(message, cause);
        captureStack($this, $this.$throwableCtor_3);
        return $this;
      }
    }
    initMetadataForClass($, 'ConnectionException');
    ConnectionExceptionClass = $;
  }
  return ConnectionExceptionClass;
}
var RateLimitedExceptionClass;
function RateLimitedException() {
  if (RateLimitedExceptionClass === VOID) {
    class $ extends ConnectionException() {
      constructor(message, retryAfter, cause) {
        return new.target.new_com_lightningkite_kiteui_RateLimitedException_gwi8l4_k$(message, retryAfter, cause);
      }
      static new_com_lightningkite_kiteui_RateLimitedException_gwi8l4_k$(message, retryAfter, cause) {
        retryAfter = retryAfter === VOID ? null : retryAfter;
        cause = cause === VOID ? null : cause;
        var $this = this.new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$(message, cause);
        captureStack($this, $this.$throwableCtor_4);
        $this.retryAfter_1 = retryAfter;
        return $this;
      }
    }
    initMetadataForClass($, 'RateLimitedException');
    RateLimitedExceptionClass = $;
  }
  return RateLimitedExceptionClass;
}
function webSocket(url) {
  _init_properties_fetch_kt__lt4al4();
  return Companion_getInstance().default_1.webSocket_6fl9o3_k$(url);
}
var RequestBlockedExceptionClass;
function RequestBlockedException() {
  if (RequestBlockedExceptionClass === VOID) {
    class $ extends FetchException() {
      constructor(message, cause) {
        return new.target.new_com_lightningkite_kiteui_RequestBlockedException_r2vfco_k$(message, cause);
      }
      static new_com_lightningkite_kiteui_RequestBlockedException_r2vfco_k$(message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_com_lightningkite_kiteui_FetchException_xi8rsd_k$(message, cause);
        captureStack($this, $this.$throwableCtor_3);
        return $this;
      }
    }
    initMetadataForClass($, 'RequestBlockedException');
    RequestBlockedExceptionClass = $;
  }
  return RequestBlockedExceptionClass;
}
var FetchExceptionClass;
function FetchException() {
  if (FetchExceptionClass === VOID) {
    class $ extends Exception() {
      static new_com_lightningkite_kiteui_FetchException_xi8rsd_k$(message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_kotlin_Exception_9qyiel_k$(message, cause);
        captureStack($this, $this.$throwableCtor_2);
        return $this;
      }
    }
    initMetadataForClass($, 'FetchException');
    FetchExceptionClass = $;
  }
  return FetchExceptionClass;
}
var RequestBodyBlobClass;
function RequestBodyBlob() {
  if (RequestBodyBlobClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestBodyBlob');
    RequestBodyBlobClass = $;
  }
  return RequestBodyBlobClass;
}
var RequestBodyFileClass;
function RequestBodyFile() {
  if (RequestBodyFileClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestBodyFile');
    RequestBodyFileClass = $;
  }
  return RequestBodyFileClass;
}
var RequestBodyTextClass;
function RequestBodyText() {
  if (RequestBodyTextClass === VOID) {
    class $ {
      constructor(content, type) {
        this.content_1 = content;
        this.type_1 = type;
      }
      toString() {
        return 'RequestBodyText(content=' + this.content_1 + ', type=' + this.type_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.content_1);
        result = imul(result, 31) + getStringHashCode(this.type_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestBodyText()))
          return false;
        if (!(this.content_1 === other.content_1))
          return false;
        if (!(this.type_1 === other.type_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RequestBodyText');
    RequestBodyTextClass = $;
  }
  return RequestBodyTextClass;
}
var ServerUnavailableExceptionClass;
function ServerUnavailableException() {
  if (ServerUnavailableExceptionClass === VOID) {
    class $ extends ConnectionException() {
      constructor(message, cause) {
        return new.target.new_com_lightningkite_kiteui_ServerUnavailableException_3w7x0a_k$(message, cause);
      }
      static new_com_lightningkite_kiteui_ServerUnavailableException_3w7x0a_k$(message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$(message, cause);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ServerUnavailableException');
    ServerUnavailableExceptionClass = $;
  }
  return ServerUnavailableExceptionClass;
}
function HttpMethod_GET_getInstance() {
  static_init();
  return HttpMethod_GET_instance;
}
function HttpMethod_POST_getInstance() {
  static_init();
  return HttpMethod_POST_instance;
}
function HttpMethod_PUT_getInstance() {
  static_init();
  return HttpMethod_PUT_instance;
}
function HttpMethod_PATCH_getInstance() {
  static_init();
  return HttpMethod_PATCH_instance;
}
function HttpMethod_DELETE_getInstance() {
  static_init();
  return HttpMethod_DELETE_instance;
}
function HttpMethod_HEAD_getInstance() {
  static_init();
  return HttpMethod_HEAD_instance;
}
var properties_initialized_fetch_kt_on2h12;
function _init_properties_fetch_kt__lt4al4() {
  if (!properties_initialized_fetch_kt_on2h12) {
    properties_initialized_fetch_kt_on2h12 = true;
    // Inline function 'kotlin.collections.mutableListOf' call
    fetchInterceptors = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  }
}
//region block: exports
export {
  ConnectionException as ConnectionException1wjs7wwnknnfm,
  RateLimitedException as RateLimitedExceptionpvooiq68cx8k,
  RequestBlockedException as RequestBlockedException1rsmv019vjn6n,
  RequestBodyBlob as RequestBodyBlob1w7e8wxebrdro,
  RequestBodyFile as RequestBodyFile26cfvm0aih79m,
  RequestBodyText as RequestBodyTextpvofjwd95b3y,
  ServerUnavailableException as ServerUnavailableException3tforh8zfc9yr,
  get_fetchInterceptors as get_fetchInterceptors6jomi3psp8vc,
  webSocket as webSockettc1n59zaskoq,
  HttpMethod_DELETE_getInstance as HttpMethod_DELETE_getInstance3fu12lv9nt4sc,
  HttpMethod_GET_getInstance as HttpMethod_GET_getInstance1esunrp6hgoe5,
  HttpMethod_HEAD_getInstance as HttpMethod_HEAD_getInstance1otx4m6279kqg,
  HttpMethod_PATCH_getInstance as HttpMethod_PATCH_getInstance296lcybjyjs1x,
  HttpMethod_POST_getInstance as HttpMethod_POST_getInstance3pqm6v4mk6ac0,
  HttpMethod_PUT_getInstance as HttpMethod_PUT_getInstance2nakgsizsajmw,
};
//endregion

//# sourceMappingURL=fetch.mjs.map
